import { SET_DATAPAGE, ADD_COUNT_DATAPAGE } from '../actions/DataPageAction'

const dataPage = {
    titulo: '',
    subTitulo: '',
    isbackend: false,
    fe_itemselect: '',
    be_itemselect: '',
    breadcrumb:[],
    type: 'NONE',
    countChange: 0
}


// eslint-disable-next-line import/no-anonymous-default-export
export default (state = dataPage, action) => {
  // console.log(action)
    switch (action.type) {
      case ADD_COUNT_DATAPAGE: 
        state.countChange = 100
        return {...state}
      case SET_DATAPAGE: 
        if (action.payload.constructor.name === "Object") {
          if(action.payload.titulo)state.titulo=action.payload.titulo
          if(action.payload.isbackend){
            state.isbackend=action.payload.isbackend
          }else{
            state.isbackend=false
          }
          if(action.payload.fe_itemselect)state.fe_itemselect=action.payload.fe_itemselect
          if(action.payload.be_itemselect)state.be_itemselect=action.payload.be_itemselect
          if(action.payload.breadcrumb)
            state.breadcrumb=action.payload.breadcrumb
          else
            state.breadcrumb=[]
        } else {
          
          state.titulo=action.payload
          state.isbackend=false
          state.breadcrumb=[]

        }
        state.countChange = 0
        return {...state};
        // return {
        //   ...state,
        //   ...action.payload,
        //   type: action.type + (cosa++).toString()
        // }
      
      default: 
        return state;
        // return {
        //   ...state, 
        //   // type: action.type + (cosa++).toString()
        // };
      
    }
  }